
import { Component, Vue } from 'vue-property-decorator'
import { selectNewsInfo, defaultNewsData, deleteNewsInfo } from '@/api/news'
import Pagination from '@/components/Pagination/index.vue'
import { INewsData } from '@/api/types'
import NewsPopper from '@/views/news/components/NewsPopper.vue'
@Component({
  components: { Pagination, NewsPopper }
})
export default class NewsRecycleBin extends Vue {
  private tableData: INewsData[] = [];
  private dialogFlag = false
  private listQuery = { page: 1, limit: 20, submitStatus: 3 };
  private tempNewsData: INewsData = defaultNewsData
  private dialogType = 'edit'
  private total = 1
  created() {
    this.getList()
  }

  private async getList() {
    const result = await selectNewsInfo(this.listQuery)
    this.tableData = result.data.list
    this.total = result.data.total
  }

  private edit(row:INewsData) {
    this.tempNewsData = Object.assign({}, row)
    this.dialogFlag = true
  }

  private closeDialog() {
    this.dialogFlag = false
  }

  private async saveData() {
    this.getList()
  }

  private deleteItem(row:INewsData) {
    const _this = this
    this.$confirm('将完全删除此条记录，不可恢复?', '警告', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        _this.tempNewsData = Object.assign({}, row)
        _this.deleteNewsInfo(row.id)
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
  }

  private async deleteNewsInfo(id:number) {
    await deleteNewsInfo(id)
    const index = this.tableData.findIndex(
      (v: INewsData) => v.id === id
    )
    this.tableData.splice(index, 1)
    this.$message({
      type: 'success',
      message: '删除成功!'
    })
  }
}
